import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ResetPasswordUseCase } from "../../../../domain/usecase/auth/ResetPassword/UseCase";
import { showGlobalLoadingView } from "../../../../core/utils/Utils";
import { State } from "../../../../domain/model/ResponseState";
import { ROUTE_ENDPOINTS } from "../../../../data/constant/RouteConstants";

export function ResetPasswordViewModel(
  resetPasswordUseCase: ResetPasswordUseCase
) {
  const { enqueueSnackbar } = useSnackbar();
  const searchParams = useSearchParams();
  const navigate = useNavigate();

  const [error, setError] = useState<string>();
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  const [email, setEmail] = useState<string>("");

  useEffect(() => {
    init();
  }, []);

  function init() {
    const searchParamsValue = searchParams[0];
    const email = searchParamsValue.get("email");
    const expiresIn = searchParamsValue.get("expiresIn");

    if (!email || !expiresIn) {
      setError("URL is not formatted properly");
      return;
    }

    const expirationDate = new Date(expiresIn);

    if (new Date().getTime() > expirationDate.getTime()) {
      setError("This link has expired");
      return;
    }

    setEmail(email);
  }

  async function changePassword(password: string) {
    showGlobalLoadingView(true);
    const response = await resetPasswordUseCase.invoke({ email, password });
    showGlobalLoadingView(false);
    switch (response.responseState) {
      case State.Success:
        setIsPasswordChanged(true);
        setTimeout(() => {
          navigate(ROUTE_ENDPOINTS.LOGIN, { replace: true });
        }, 2000);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error"
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { error, isPasswordChanged, changePassword };
}
